import React, { useState, useEffect } from "react";
import { useNavigate, Link, useLocation } from "react-router-dom";
import { useAuth } from "../../../contexts/AuthContext";
import { Button } from "../../ui/button";
import { CodeInputWithResend } from "../CodeInputWithResend";
import LoadingSpinner from "../../loading-spinner/LoadingSpinner";

export default function ConfirmSignUpForm() {
  const navigate = useNavigate();
  const location = useLocation();
  const [code, setCode] = useState("");
  const { confirmSignup, loading, resendCode } = useAuth();

  const email = location.state?.username || localStorage.getItem('mb_userEmail');

  useEffect(() => {
    if (!email) {
      navigate('/signup');
    }
  }, [email, navigate]);

  const handleConfirm = async (e) => {
    e.preventDefault();
    try {
      await confirmSignup(email, code);
      alert("Email confirmed! You can now login.");
      navigate("/login");
    } catch (err) {
      alert("Error confirming sign up: " + err.message);
    }
  };

  const handleResendCode = async () => {
    await resendCode(email);
    alert("Confirmation code resent!");
  };

   if (loading) {
      return (
        <div className="p-4 flex items-center justify-center min-h-[40vh]">
          <LoadingSpinner />
        </div>
      );
    }

  return (
    <div className="h-[calc(100vh-40px)] flex items-center justify-center px-4">
      <div className="mx-auto w-full max-w-sm space-y-6">
        <div className="text-center space-y-2">
          <h1 className="text-2xl font-semibold tracking-tight">
            Confirm Sign Up
          </h1>
          <p className="text-sm text-muted-foreground">
            Enter the confirmation code sent to your email
          </p>
        </div>

        <form onSubmit={handleConfirm} className="space-y-4">
          <CodeInputWithResend
            code={code}
            setCode={setCode}
            onResend={handleResendCode}
            email={email}
            label="Confirmation Code"
          />

          <Button type="submit" className="w-full" disabled={loading}>
            Confirm
          </Button>
        </form>
        
        <p className="px-8 text-center text-sm text-muted-foreground">
          <Link to="/signup" className="underline underline-offset-4">
            Back to sign up
          </Link>
        </p>
      </div>
    </div>
  );
}